import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';


function Footer() {
    useEffect(() => {
        // Sayfa yenilendiğinde veya bağlantıya tıklandığında sayfanın başına kaydır
        const handleScrollToTop = () => {
            window.scrollTo(0, 0);
        };

        // Linklere tıklama olayını dinleyen bir event listener ekleyelim
        document.querySelectorAll('.footer-box.pages a').forEach(anchor => {
            anchor.addEventListener('click', handleScrollToTop);
        });

        // useEffect temizleyicisi ile event listener'ı kaldıralım
        return () => {
            document.querySelectorAll('.footer-box.pages a').forEach(anchor => {
                anchor.removeEventListener('click', handleScrollToTop);
            });
        };
    }, []); // Boş bağımlılık dizisi, sadece bir kez çalışmasını sağlar

    useEffect(() => {
        $(document).ready(function(){
            $('.logo-carousel-inner').owlCarousel({
                items: 5,
                loop: true,
                margin: 10,
                autoplay: true,
                autoplayTimeout: 3000,
                autoplayHoverPause: true,
                responsive: {
                    0: {
                        items: 2 // Mobil ekranlarda 2 logo göstermek için
                    },
                    600: {
                        items: 3 // 600px'ye kadar olan ekranlarda 3 logo göstermek için
                    },
                    1000: {
                        items: 5 // Büyük ekranlarda 5 logo göstermek için
                    }
                }
            });
        });
    }, []);
    

    return (
        <>
            {/* logo carousel */}
            <div className="logo-carousel-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="logo-carousel-inner">
                                <div className="single-logo-item">
                                    <img src="/assets/img/footer_lig/1.png" alt="" />
                                </div>
                                <div className="single-logo-item">
                                    <img src="/assets/img/footer_lig/2.png" alt="" />
                                </div>
                                <div className="single-logo-item">
                                    <img src="/assets/img/footer_lig/3.png" alt="" />
                                </div>
                                <div className="single-logo-item">
                                    <img src="/assets/img/footer_lig/4.png" alt="" />
                                </div>
                                <div className="single-logo-item">
                                    <img src="/assets/img/footer_lig/5.png" alt="" />
                                </div>
                                <div className="single-logo-item">
                                    <img src="/assets/img/footer_lig/6.png" alt="" />
                                </div>
                                {/* <div className="single-logo-item">
    <img src="/assets/img/footer_lig/7.png" alt="" />
</div> */}

                                <div className="single-logo-item">
                                    <img src="/assets/img/footer_lig/8.png" alt="" />
                                </div>
                                <div className="single-logo-item">
                                    <img src="/assets/img/footer_lig/9.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* end logo carousel */}

            {/* footer */}
            <div className="footer-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="footer-box about-widget">
                                <h2 className="widget-title">Hakkımızda</h2>
                                <p>Güçlü editör ekibimizle, iddialı ve en doğru ve güvenilir bilgiyi ulaştırmayı amaçlıyoruz. Editörlerimizin uzmanlığı ve deneyimi, kuruluşumuzun kalitesini ve güvenilirliğini garantiliyor.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="footer-box pages">
                                <h2 className="widget-title">Sayfalar</h2>
                                <ul>
                                    <li><Link to="/" className={window.location.pathname === '/' ? 'active' : ''}>Ana Sayfa</Link></li>
                                    <li><Link to="/about" className={window.location.pathname === '/about' ? 'active' : ''}>Hakkımızda</Link></li>
                                    <li><Link to="/editor" className={window.location.pathname === '/news' ? 'active' : ''}>Editörlerin Seçimi</Link></li>
                                    <li><Link to="/acilisoran" className={window.location.pathname === '/acilisoran' ? 'active' : ''}>Açılış Oranlar</Link></li>
                                    <li><Link to="/kapanisoran" className={window.location.pathname === '/kapanisoran' ? 'active' : ''}>Kapanış Oranlar</Link></li>
                                    <li><Link to="/uyeliksozlesmesi" className={window.location.pathname === '/uyeliksozlesmesi' ? 'active' : ''}>Üyelik Sözleşmesi</Link></li>


                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="footer-box social-widget">
                                <h2 className="widget-title">Sosyal Medya</h2>
                                <div className="social-icons">
                                    <ul>
                                        <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a></li>
                                        <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                                        <li><a href="https://telegram.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-dribbble"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end footer */}
        </>
    );
}

export default Footer;
